import {
  IonApp,
  IonRouterOutlet,

} from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import { Redirect, Route, Switch } from "react-router-dom";
import HomeContent from "../pages/Home/HomeContent";

import { useAuth } from "../contexts/AuthContext";
import Tabs from "./Tabs";
import PrivateRoute from "./PrivateRoute";
import { useParams } from "react-router-dom";
import { getStudySlug } from "../helper/study";



const Navigator: React.FC = () => {
  // For loading state
  const { isInitialized, isAuthenticated } = useAuth();

  const outletKey = isAuthenticated ? "auth" : "guest";
  const slug = getStudySlug() || "mentalplus";

  return (
    <IonApp>
      <IonReactRouter>
        <IonRouterOutlet>
          {/* Default root → redirect to mentalplus */}
          <PrivateRoute exact path="/" render={() => <Redirect to="/mentalplus/tabs/home" />} />

          {/* Public route */}
          <Route exact path="/:study_slug/welcome" component={HomeContent} />
          <Route path="/:study_slug/tabs" render={() => <Tabs />} />
           {/* Fallback */}
          <Route>
            {isAuthenticated ? (
              <Redirect to={`/${slug}/tabs/home`} />
            ) : (
              <Redirect to={`/${slug}/welcome`} />
            )}
          </Route>
        </IonRouterOutlet>
      </IonReactRouter>
    </IonApp>
  );
};

export default Navigator;
